var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Service = (function (Service) {

        Service.call = function (options) {
            var defOpts, opts, serviceUrl, onErrorInternal;

            defOpts = {
                async: true,
                method: options.method || 'POST',
                url: '#',
                data: {},
                rawdata: false,
                servicenamespace: options.servicenamespace || 'services',
                onSuccess: function (response) {
                },
                onFailure: function (err) {
                    throw err;
                },
                onUnauthenticated: function (url) {
                    throw new Error('not implemented: onUnauthenticated(url)');
                }
            };

            opts = { ...defOpts, ...options };

            serviceUrl = /^([^:]+:)?\/\//.test(opts.url) ?      // is it an absolute url? dont't touch it
                    opts.url :
                    document.location.protocol.toLowerCase()
                        + '//' + document.location.host.toLowerCase()
                        + (opts.servicenamespace ? '/' + opts.servicenamespace : '')
                        + '/' + opts.url;

            serviceUrl = serviceUrl.split('?')[0];

            var locationQueryParams = LhApp.Function.QueryString.parse(window.location.href);

            var serviceQueryParams = LhApp.Function.QueryString.parse(opts.url);

            ///force current page language in every service request
            if (!serviceQueryParams['lang']) {
                serviceQueryParams['lang'] = (locationQueryParams['lang'] || LhApp.Context.Language).toLowerCase();;
            }
            ///force country in every service request IF PRESENT in current url
            if (!serviceQueryParams['country'] && locationQueryParams['country']) {
                serviceQueryParams['country'] = locationQueryParams['country'].toLowerCase();
            }
            ///force currency in every service request IF PRESENT in current url
            if (!serviceQueryParams['currency'] && locationQueryParams['currency']) {
                serviceQueryParams['currency'] = locationQueryParams['currency'].toLowerCase();
            }
            
            var _data = {};
            var _query;
            //if is get request the data will be posted as query. any key present in queryparams will be overriten by the value of the same key (if exists) in data
            if ((options.method || 'POST').toUpperCase() == 'GET') {
                if (Object.keys(opts.data).length > 0) {
                    Object.keys(opts.data).forEach(function (key) {
                        _data[key.toLowerCase()] = opts.data[key];
                    });
                }
                _data = { ...serviceQueryParams, ...opts.data };
            }
            else {
                _data = opts.data;
                _query = $.param(serviceQueryParams).toString();
            }

            if (_query)
                serviceUrl += '?' + _query; 

            onErrorInternal = function (ex) {
                if (ex && ex.responseJSON && ex.responseJSON.ExceptionType) {
                    var typeName = ex.responseJSON.ExceptionType.split('.').pop();

                    if (typeName === 'AuthenticationServiceException') {
                        if (typeof (opts.onUnauthenticated) === 'function') {
                            opts.onUnauthenticated(ex.responseJSON.Message);
                        }
                        else {
                            throw ex;
                        }
                    }
                    else {
                        if (typeof (opts.onFailure) === 'function') {
                            opts.onFailure(ex);
                        }
                        else {
                            throw ex;
                        }
                    }
                }
                else {
                    if (typeof (opts.onFailure) === 'function') {
                        opts.onFailure(ex);
                    }
                    else {
                        throw ex;
                    }
                }
            };

            $.ajax({
                async: opts.async || true,
                type: opts.method,
                dataType: opts.rawdata ? 'text' : 'json',
                contentType: opts.rawdata ? '' : 'application/json; charset=UTF-8',
                ContentType: opts.rawdata ? '' : 'application/json; charset=UTF-8',
                url: serviceUrl,
                data: (opts.method == 'GET') ? _data : opts.rawdata ? _data : JSON.stringify(_data),
                success: function (response) {

                    var obj = response;

                    if (response.d)
                        obj = response.d;

                    if (typeof obj === 'string' || obj instanceof String)
                        obj = JSON.parse(obj);

                    if (typeof (opts.onSuccess) === 'function') {
                        opts.onSuccess(obj);
                    }
                },
                failure: function (ex) {
                    onErrorInternal(ex);
                },
                error: function (ex) {
                    onErrorInternal(ex);
                }
            });
        };

        return Service;

    })(Vendd.Service || {});

    return Vendd;

})(Vendd || {});